import LayoutPadrao from '../layouts/LayoutPadrao.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'bot-controle',
      name: 'bot-controle',
      component: () => import('../views/bot-controle/BotControleView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Controle de Bot',
        nome_fisico: 'bot-controle',
      },
    },
  ],
}
